module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1040-8e51c6ad05cd5da06c1e749597313eda.png";